module.exports = __webpack_public_path__ + "img/D201710_4.ced0bb86.jpg";